import styled from 'styled-components';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;

  .custom-tooltip {
    padding: 15px;
    padding-right: 0px;
    display: flex;
    flex-direction: column;
    gap: 0px;

    .section {
      display: flex;
      
      .value {
        flex: 1;
        font-size: 12px;
        white-space: nowrap;

        &.week-val {
          width: 90px;
          text-align: center;
        }

        &.total-val {
          width: 50px;
          text-align: center;
        }

        &.sources {
          font-size: 12px;
        }
      }

      .label {
        overflow: hidden;
        width: 110px;
        padding-left: 0px;
        display: flex;
        padding-right: 8px;
        
        h4 {
          font-size: 15px;
          font-weight: 700;
        }

        &.sources {
          h4 {
            font-size: 12px;
            font-weight: 500;
          }
        }
        
        .legend {
          min-width: 8px;
          min-height: 8px;
          width: 8px;
          height: 8px;
          border-radius: 100%;
          margin-top: 2px;
          margin-right: 4px;
        }

        h4 {
          font-size: 13px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        label {
          font-size: 13px;
        }
      }
    }
  }

  .overview-header {
    display: flex;
    padding: 8px 0 14px 0;
    gap: 8%;

    .value {
      flex: 1;
      display: flex;
      gap: 8px;

      p {
        font-size: var(--font-size-lg);
        font-weight: 500;
        color: #344054;

        &.main {
          flex: 1;
          font-weight: 500;
        }
      }
    }
  }
`;

export default Style;
